import type { WidgetDefinition, DashboardFetcher, AllowedInternalRoutes, DataSourceOption } from '../types';

/**
 * GET /api/dashboard/widgets
 * Devuelve el catálogo de widgets filtrado por el rol del usuario (vía JWT en el host).
 */
export const getCatalogWidgets = async (
  fetcher: DashboardFetcher
): Promise<WidgetDefinition[]> => {
  return fetcher<WidgetDefinition[]>('/api/dashboard/widgets', { method: 'GET' });
};

/**
 * POST /api/dashboard/widgets
 * Registra un widget creado desde el Widget Builder.
 */
export const createWidget = async (
  newWidget: Omit<WidgetDefinition, 'version'>,
  fetcher: DashboardFetcher
): Promise<WidgetDefinition> => {
  return fetcher<WidgetDefinition>('/api/dashboard/widgets', {
    method: 'POST',
    body: newWidget,
  });
};

/**
 * PATCH /api/dashboard/widgets/:widgetId
 * Actualiza un widget existente (campos parciales).
 */
export const updateWidget = async (
  widgetId: string,
  patch: Partial<WidgetDefinition>,
  fetcher: DashboardFetcher
): Promise<WidgetDefinition> => {
  return fetcher<WidgetDefinition>(`/api/dashboard/widgets/${widgetId}`, {
    method: 'PATCH',
    body: patch,
  });
};

/**
 * DELETE /api/dashboard/widgets/:widgetId
 * Elimina un widget del catalogo (requiere rol admin).
 */
export const deleteWidget = async (
  widgetId: string,
  fetcher: DashboardFetcher
): Promise<{ deleted: boolean }> => {
  return fetcher<{ deleted: boolean }>(`/api/dashboard/widgets/${widgetId}`, {
    method: 'DELETE',
  });
};

/**
 * GET /api/dashboard/widgets/allowed-internal-routes
 * Retorna la configuracion publica del whitelist para el Widget Builder.
 */
export const getAllowedInternalRoutes = async (
  fetcher: DashboardFetcher
): Promise<AllowedInternalRoutes> => {
  return fetcher<AllowedInternalRoutes>('/api/dashboard/widgets/allowed-internal-routes', { method: 'GET' });
};

/**
 * GET /api/dashboard/widgets/data-sources
 * Retorna el catalogo de fuentes internas filtrado por roles del usuario.
 */
export const getDataSources = async (
  fetcher: DashboardFetcher
): Promise<DataSourceOption[]> => {
  return fetcher<DataSourceOption[]>('/api/dashboard/widgets/data-sources', { method: 'GET' });
};
